import { FormControl, FormLabel, TextField as MuiTextField, useMediaQuery, useTheme } from '@mui/material';

type Props = {
  label?: string;
  value: string;
  type?: string;
  multiline?: boolean;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error?: string;
  maxLength?: number;
  rows?: number;
  maxRows?: number;
  placeholder?: string;
  fullWidth?: boolean;
  onEnterKey?: () => void;
  onChange?: (value: string) => void;
  endAdornment?: any;
};

const TextField = ({
  label,
  value,
  type,
  multiline,
  required,
  disabled,
  autoFocus,
  error,
  maxLength,
  rows,
  maxRows,
  placeholder,
  fullWidth = true,
  onEnterKey,
  onChange,
  endAdornment,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const actualFullWidth = isMobile ? true : fullWidth;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl variant="standard" fullWidth={actualFullWidth} sx={{ marginTop: 0 }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <MuiTextField
        variant="outlined"
        value={value}
        label={''}
        fullWidth={actualFullWidth}
        margin="dense"
        required={required}
        multiline={multiline}
        rows={rows}
        maxRows={maxRows}
        size="small"
        error={error !== undefined && error !== ''}
        helperText={error}
        disabled={disabled}
        onChange={handleChange}
        sx={{ marginTop: 0, padding: 0 }}
        type={type}
        autoFocus={autoFocus}
        placeholder={placeholder}
        inputProps={{ maxLength }}
        InputProps={{
          endAdornment: endAdornment,
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onEnterKey) {
            onEnterKey();
          }
        }}
      />
    </FormControl>
  );
};

export default TextField;
